import React from 'react';
import ReactLoader from 'react-loading';

import { withTheme } from 'styled-components';

import { StyledButton, ButtonLabel, Box } from './styles';

export interface Props {
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  value?: string;
  disabled?: boolean;
  loading?: boolean;
  invertedColor?: boolean;
  children?: React.ReactNode | JSX.Element | JSX.Element[];
  theme?: any;
  target?: string;
  testId?: string;
  noBorder?: boolean;
}

const LoaderButton = ({ fontColor }: { fontColor: string }) => (
  <Box>
    <ReactLoader type="spinningBubbles" color={fontColor} width={30} height={30} />
  </Box>
);

const Button = ({ value, loading, children, theme, type, target, testId, noBorder, ...rest }: Props) => (
  <StyledButton id={target} type={!type ? 'submit' : type} data-testid={testId} {...rest} $noBorder={noBorder}>
    <ButtonLabel $loading={loading}>{children || value}</ButtonLabel>
    {loading && <LoaderButton fontColor={theme.loading} />}
  </StyledButton>
);

export default withTheme(Button);
